<template>
  <div>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Tạo phiếu không phục vụ được'">
          <template v-slot:preview>
            <b-row>
              <b-col md="8">
                <!-- Customer Information -->
                <div class="customer-section mb-4">
                  <h5 class="mb-3">Thông tin khách hàng</h5>
                  
                  <!-- Customer Phone -->
                  <b-form-group>
                    <label>Số điện thoại:<b class="text-danger">*</b></label>
                    <b-form-input
                      v-model="mainModel.customerPhone"
                      placeholder="Nhập số điện thoại"
                      size="sm"
                      required
                      trim
                      :state="isPhoneValid"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      v-if="mainModel.customerPhone && !isPhoneValid"
                    >
                      Số điện thoại không hợp lệ. Vui lòng nhập số điện thoại Việt Nam hợp lệ.
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <!-- Customer Name and Gender -->
                  <b-row>
                    <b-col md="8">
                      <b-form-group>
                        <label>Họ và tên:<b class="text-danger">*</b></label>
                        <b-form-input
                          v-model="mainModel.customerName"
                          placeholder="Nhập tên khách hàng"
                          size="sm"
                          required
                          trim
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <label>Giới tính:<b class="text-danger">*</b></label>
                        <b-form-select
                          v-model="mainModel.customerAppellation"
                          :options="genderOptions"
                          value-field="id"
                          text-field="name"
                          size="sm"
                          required
                          trim
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>
                              -- Chọn giới tính --
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  
                  <!-- Auto fill checkbox -->
                  <b-form-group>
                    <b-form-checkbox
                      :checked="autoFillCustomer"
                      @change="onAutoFillChange"
                    >
                      Tự động điền thông tin mặc định
                    </b-form-checkbox>
                  </b-form-group>
                </div>

                <!-- Description -->
                <div class="description-section mb-4">
                  <h5 class="mb-3">Mô tả phiếu</h5>
                  <b-form-group>
                                      <b-form-textarea
                    v-model="mainModel.description"
                    placeholder="Nhập mô tả của phiếu..."
                    :rows="4"
                    :max-rows="6"
                    size="sm"
                    trim
                  ></b-form-textarea>
                  </b-form-group>
                </div>

                <!-- Product Search -->
                <div class="product-section mb-4">
                  <h5 class="mb-3">Sản phẩm</h5>
                  <b-form-group>
                    <label>Tìm kiếm sản phẩm:</label>
                    <treeselect
                      :load-options="loadOptionProducts"
                      :multiple="false"
                      :async="true"
                      :placeholder="'Tìm kiếm theo tên, mã, mã vạch sản phẩm'"
                      :cache-options="false"
                      retryText="Thử lại..."
                      retryTitle="Nhấp thử lại"
                      searchPromptText="Nhập để tìm kiếm..."
                      loadingText="Đang tải..."
                      noResultsText="Không có kết quả"
                      openDirection="bottom"
                      @select="onSelectedProduct"
                      @input="onSelectedProduct"
                      @change="onSelectedProduct"
                      :always-open="isOpenProductSearch"
                      @search-change="onSearchChange"
                      :clearable="true"
                      :close-on-select="true"
                      :default-expand-level="0"
                      :disable-branch-nodes="true"
                    >
                      <label
                        slot="option-label"
                        slot-scope="{ node, labelClassName }"
                        :class="labelClassName"
                      >
                        <template>
                          <div>
                            {{ node.raw.label }}
                          </div>
                        </template>
                      </label>
                    </treeselect>
                  </b-form-group>

                  <!-- Selected Products List -->
                  <div v-if="mainModel.orderProServes.length > 0" class="mt-3">
                    <h6>Danh sách sản phẩm đã chọn:</h6>
                    <b-table
                      :items="mainModel.orderProServes"
                      :fields="productTableFields"
                      striped
                      hover
                      small
                      class="selected-products-table"
                    >
                      <template #cell(productName)="data">
                        <strong>{{ data.item.productName }}</strong>
                        <small class="text-muted ml-2" v-if="data.item.productCode">
                          ({{ data.item.productCode }})
                        </small>
                      </template>
                      <template #cell(actions)="data">
                        <b-button
                          size="sm"
                          variant="danger"
                          @click="removeProduct(data.index)"
                        >
                          <i class="fas fa-trash"></i>
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-col>

              <b-col md="4">
                <!-- Reason Selection -->
                <div class="reason-section mb-4">
                  <h5 class="mb-3">Lý do không phục vụ</h5>
                  <b-form-group>
                    <b-form-select
                      v-model="mainModel.reasonId"
                      :options="listReason"
                      value-field="id"
                      text-field="name"
                      size="sm"
                      required
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>
                          -- Chọn lý do --
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
          </template>
          <template v-slot:foot>
            <div class="row">
              <div class="col-md-5">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="saveOrderCantServe"
                  :disabled="!isValidForm"
                >
                  <i class="fas fa-save"></i>
                  <span class="font-weight-bolder">Lưu</span>
                </b-button>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click="navigateToOrderCantServe"
                  class="ml-2"
                >
                  <i class="fas fa-arrow-left"></i>
                  <span class="font-weight-bolder">Quay lại</span>
                </b-button>
              </div>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Loader from '@/view/content/Loader.vue';
import ApiService from '@/core/services/api.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { v4 as uuidv4 } from 'uuid';
import { makeToastFaile, makeToastSuccess, cleanEmptyParams } from '@/utils/common';
import { CUSTOMER_GENDER, SUCCESS_RESPONSE_STATUS } from '@/utils/constants';

const isValidPhoneNumberForForm = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  // Special case for 18006018
  if (value === '18006018') {
    return true;
  }
  return /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(value);
};

export default {
  data() {
    return {
      loaderEnabled: false,
      loaderLogo: '',

      autoFillCustomer: false,
      
      mainModel: {
        customerPhone: '',
        customerName: '',
        customerAppellation: null,
        description: '',
        orderProServes: [],
        reasonId: null,
      },

      isOpenProductSearch: false,
      productSearchTemp: null,

      listReason: [],

      defaultCustomerInfo: {
        customerPhone: '18006018',
        customerName: 'A Di Động Việt',
        customerAppellation: 1, // Nam (MALE)
      },
      
      genderOptions: [],
      
      productTableFields: [
        { key: 'productName', label: 'Tên sản phẩm' },
        { key: 'actions', label: 'Thao tác', class: 'text-center' }
      ],
    };
  },

  components: {
    KTCodePreview,
    Treeselect,
    Loader,
  },

  computed: {
    isValidForm() {
      return (
        this.mainModel.customerPhone &&
        this.isPhoneValid &&
        this.mainModel.customerName &&
        this.mainModel.reasonId &&
        this.mainModel.orderProServes.length > 0
      );
    },
    isPhoneValid() {
      if (!this.mainModel.customerPhone) return null;
      return isValidPhoneNumberForForm(this.mainModel.customerPhone);
    },
  },

  created() {
    this.fetchReasons();
    this.genderOptions = CUSTOMER_GENDER.filter(option => option.id !== null);
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu không phục vụ được', route: '/order-cant-serve' },
      { title: 'Tạo mới', route: '/order-cant-serve/create' },
    ]);
  },

  methods: {
    onAutoFillChange(checked) {
      this.autoFillCustomer = checked;
      if (checked) {
        this.mainModel.customerPhone = this.defaultCustomerInfo.customerPhone;
        this.mainModel.customerName = this.defaultCustomerInfo.customerName;
        this.mainModel.customerAppellation = this.defaultCustomerInfo.customerAppellation;      
      } else {
        this.mainModel.customerPhone = '';
        this.mainModel.customerName = '';
        this.mainModel.customerAppellation = null;
      }
    },

    onSearchChange(searchQuery) {
      if (searchQuery && typeof searchQuery === 'string') {
        this.isOpenProductSearch = true;
      } else {
        this.isOpenProductSearch = false;
      }
    },
    onSelectedProduct(node) {
      if (!node) return;
      
      if (node.raw) {
        const product = {
          productId: node.raw.productId,
          productName: node.raw.productName,
          productCode: node.raw.productCode,
        };
        
        const exists = this.mainModel.orderProServes.find(p => p.productId === product.productId);
        if (!exists) {
          this.mainModel.orderProServes.push(product);
        }
        
        this.isOpenProductSearch = false;
      } else if (node.productId) {
        const product = {
          productId: node.productId,
          productName: node.productName,
          productCode: node.productCode,
        };
        
        const exists = this.mainModel.orderProServes.find(p => p.productId === product.productId);
        if (!exists) {
          this.mainModel.orderProServes.push(product);
        }
        
        this.isOpenProductSearch = false;
      }
    },

    removeProduct(index) {
      this.mainModel.orderProServes.splice(index, 1);
    },


    async loadOptionProducts({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        try {
          this.productSearchTemp = searchQuery;
          const result = await this.searchProductAPI(searchQuery);

          const optionProduct = (result.data || []).map((element) => {
            return {
              id: element.productId || uuidv4(),
              label: element.productName,
              raw: element,
              productId: element.productId,
              productName: element.productName,
              productCode: element.productCode,
            };
          });

          callback(null, optionProduct);
        } catch (error) {
          console.error('Error loading product options:', error);
          callback(null, []);
        }
      }
    },

    async searchProductAPI(searchQuery) {
      const params = cleanEmptyParams({
        searchProduct: searchQuery ? searchQuery.trim() : null,
      });
      const response = await ApiService.query('productSearch', { params });
      return response.data;
    },

    fetchReasons() {
      ApiService.get('order-cant-serve/reasons')
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.listReason = response.data.data;
          } else {
            this.listReason = [];
          }
        })
        .catch((error) => {
          console.error('Error fetching reasons:', error);
          makeToastFaile('Không thể tải danh sách lý do không phục vụ');
          this.listReason = [];
        });
    },

    saveOrderCantServe() {
      if (!this.isValidForm) {
        makeToastFaile('Vui lòng điền đầy đủ thông tin bắt buộc');
        return;
      }

      this.loaderEnabled = true;

      const orderCantServeData = {
        customerPhone: this.mainModel.customerPhone,
        customerName: this.mainModel.customerName,
        customerAppellation: this.mainModel.customerAppellation,
        description: this.mainModel.description,
        orderProServes: this.mainModel.orderProServes.map(product => ({
          productId: product.productId || "",
          productName: product.productName,
          reasonId: this.mainModel.reasonId
        }))
      };

      ApiService.post('order-cant-serve/mobile', orderCantServeData)
        .then((response) => {
          const { status } = response.data;
          if (status === SUCCESS_RESPONSE_STATUS) {
            makeToastSuccess('Tạo phiếu thành công'); 
            this.navigateToOrderCantServe();
          }
          this.navigateToOrderCantServe();
        })
        .catch((error) => {
          console.error('Error creating order:', error);
          makeToastFaile(error.message);
        })
        .finally(() => {
          this.loaderEnabled = false;
        });
    },

    navigateToOrderCantServe() {
      this.$router.push({ name: 'order-cant-serve' });
    },
  },
};
</script>

<style scoped>
.customer-section,
.description-section,
.product-section,
.reason-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.selected-products-table {
  max-height: 300px;
  overflow-y: auto;
}

.selected-products-table .table {
  margin-bottom: 0;
}
</style> 